import { MERCHANT } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";

export type GetMerchantFeaturePreferenceRequestAction = Action<
    {
        merchantId: string;
        collectionId: string;
    },
    {}
>;
export const getMerchantFeaturePreferenceRequest = (
    merchantId: string,
    collectionId?: string
): GetMerchantFeaturePreferenceRequestAction => ({
    meta: {},
    payload: { merchantId, collectionId },
    type: MERCHANT.FEATURE_PREFERENCE.GET.REQUEST,
});

export type GetMerchantFeaturePreferenceCompleteAction = Action<
    nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error,
    {}
>;
export const getMerchantFeaturePreferenceComplete = (
    payload: nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error
): GetMerchantFeaturePreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.FEATURE_PREFERENCE.GET.COMPLETE,
});

export type CreateMerchantFeaturePreferenceRequestAction = Action<
    {
        merchantId: string;
        featurePreference: nuorder.collection.merchant_feature_config.MerchantFeatureConfig;
    },
    {}
>;
export const createMerchantFeaturePreferenceRequest = (
    merchantId: string,
    featurePreference: nuorder.collection.merchant_feature_config.MerchantFeatureConfig
): CreateMerchantFeaturePreferenceRequestAction => ({
    meta: {},
    payload: { merchantId, featurePreference },
    type: MERCHANT.FEATURE_PREFERENCE.CREATE.REQUEST,
});

export type CreateMerchantFeaturePreferenceCompleteAction = Action<
    nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error,
    {}
>;
export const createMerchantFeaturePreferenceComplete = (
    payload: nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error
): CreateMerchantFeaturePreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.FEATURE_PREFERENCE.CREATE.COMPLETE,
});

export type UpdateMerchantFeaturePreferenceRequestAction = Action<
    {
        merchantId: string;
        featurePreference: nuorder.collection.merchant_feature_config.MerchantFeatureConfig;
    },
    {}
>;
export const updateMerchantFeaturePreferenceRequest = (
    merchantId: string,
    featurePreference: nuorder.collection.merchant_feature_config.MerchantFeatureConfig
): UpdateMerchantFeaturePreferenceRequestAction => ({
    meta: {},
    payload: { merchantId, featurePreference },
    type: MERCHANT.FEATURE_PREFERENCE.UPDATE.REQUEST,
});

export type UpdateMerchantFeaturePreferenceCompleteAction = Action<
    nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error,
    {}
>;
export const updateMerchantFeaturePreferenceComplete = (
    payload: nuorder.collection.merchant_feature_config.MerchantFeatureConfig | Error
): UpdateMerchantFeaturePreferenceCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.FEATURE_PREFERENCE.UPDATE.COMPLETE,
});
